import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { ActivityNoteBlock } from "web_myplann/Activities/Components/ActivityNoteBlock";
import type { ClientActivityNoteItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

const R = Resources.Activity.Detail;

type Props = {
	notes: ClientActivityNoteItemResponseDTO[];
};

export const ActivityNotesSection: FC<Props> = ({ notes }) => {
	const { t } = useResource();

	return (
		<>
			<Typography variant="sectionLabel">{t(R.notes)}</Typography>
			<Stack bgcolor="background.paper">
				{notes.map((note, index) => (
					<ActivityNoteBlock
						key={note.id}
						title={note.title ?? ""}
						content={note.text ?? ""}
						showDivider={index < notes.length - 1}
					/>
				))}
			</Stack>
		</>
	);
};
